var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon20(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3538_5292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.25 10.7521C21.0383 10.7573 18.8808 10.0867 17.0823 8.83512V17.5639C17.0817 19.1806 16.5734 20.7585 15.6254 22.0868C14.6775 23.415 13.335 24.4302 11.7775 24.9967C10.22 25.5632 8.52174 25.6539 6.9098 25.2566C5.29785 24.8594 3.84906 23.9933 2.75714 22.774C1.66522 21.5547 0.982221 20.0403 0.79947 18.4335C0.61672 16.8266 0.942928 15.2038 1.73448 13.782C2.52602 12.3602 3.74518 11.2073 5.22893 10.4773C6.71268 9.74735 8.3903 9.47517 10.0375 9.69715V14.0874C9.28372 13.8569 8.47433 13.8639 7.72489 14.1073C6.97544 14.3507 6.32427 14.818 5.86436 15.4427C5.40444 16.0673 5.15931 16.8173 5.16396 17.5854C5.16862 18.3536 5.42282 19.1007 5.89027 19.72C6.35772 20.3394 7.01451 20.7993 7.76685 21.034C8.5192 21.2688 9.32861 21.2665 10.0795 21.0274C10.8304 20.7883 11.4844 20.3246 11.9481 19.7026C12.4117 19.0806 12.6614 18.3321 12.6614 17.5639V0.5H17.0823C17.0792 0.862953 17.1105 1.22541 17.1758 1.58279C17.3294 2.38059 17.6488 3.13954 18.1145 3.81321C18.5801 4.48688 19.1823 5.06111 19.8841 5.50078C20.8825 6.14259 22.0531 6.48467 23.25 6.48443V10.7521Z",
    fill: "url(#paint0_linear_3538_5292)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3538_5292",
    x: 0.75,
    y: 0.5,
    width: 22.5,
    height: 27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3538_5292"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3538_5292",
    x1: 12,
    y1: 0.5,
    x2: 11.75,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43CBF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB358F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon20);
export default __webpack_public_path__ + "static/media/icon20.9c2e79cc08ef5248fbf9c80cc96ef3c4.svg";
export { ForwardRef as ReactComponent };